import { useQuotationHeaderCondition } from './hooks/useQuotationHeaderCondition.hook';
import { hasModalities } from './utils/quotation-header-conditions.util';
import type {
  ResolverParameters,
  ResolverResult,
} from '../types/resolvers.type';

export const useDevisAvecModalites = (
  parameters: Readonly<ResolverParameters>,
): ResolverResult<boolean> =>
  useQuotationHeaderCondition(parameters, hasModalities);
